import { inject, Injectable, signal } from '@angular/core';
import {
  Transaction,
  TransactionStatus,
  TransactionType,
} from '../schemas/transaction';
import { createItem, readItems, updateItem } from '@directus/sdk';
import { directusAuthInstance } from '../libs/directus';
import { HandleErrorsService } from '../utils/services/handle-errors.service';
import { RequestsService } from '../utils/services/requests.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionService {
  private handleErrorsService = inject(HandleErrorsService);
  private requestsService = inject(RequestsService);
  public transactions = signal<Transaction[]>([]);
  directusClient = directusAuthInstance;
  constructor() {}

  async createTransaction(transaction: Transaction) {
    // console.log('transaction', transaction);
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    // return;
    const { ...data } = transaction;
    try {
      const transactionResponse = await this.requestsService.handleRequest(() =>
        this.directusClient.request(createItem('transactions', data)),
      );
      // await this.getTransactions();
      return transactionResponse as Transaction;
    } catch (error) {
      this.handleErrorsService.handleErrors(error);
      return null;
    }
  }

  async updateTransaction(transaction: Transaction) {
    // await new Promise((resolve) => setTimeout(resolve, 3000));
    // console.log('transaction', transaction);
    // return;

    const { id, ...data } = transaction;

    try {
      const transactionResponse = await this.requestsService.handleRequest(() =>
        this.directusClient.request(
          updateItem('transactions', transaction.id!, data),
        ),
      );
      return transactionResponse as Transaction;
    } catch (error) {
      this.handleErrorsService.handleErrors(error);
      return null;
    }
  }

  async getTransactions(): Promise<Transaction[]> {
    try {
      const transactions = await this.requestsService.handleRequest(() =>
        this.directusClient.request(
          readItems('transactions', {
            fields: ['*.*.*'],
            sort: '-date_created',
            limit: -1,
          }),
        ),
      );

      if (transactions.length === 0) {
        return [];
      }
      this.transactions.set(transactions as Transaction[]);
      return transactions as Transaction[];
    } catch (error) {
      this.handleErrorsService.handleErrors(error);
      return [];
    }
  }

  async generateTransactions(): Promise<Transaction[]> {
    const transactions: Transaction[] = [];
    for (let i = 0; i < 50; i++) {
      transactions.push({
        id: `${i}`,
        amount: (Math.random() * 100000).toFixed(0),
        code: `TRX${i}`,
        label: 'Cash In',
        type: this.getRandomTransactionType(),
        status: this.getRandomTransactionStatus(),
        sender_status: this.getRandomTransactionStatus(),
        receiver_status: this.getRandomTransactionStatus(),
        sender_account: '',
        receiver_account: '',
        sender: '',
        receiver: '',
        date_created: new Date().toISOString(),
        date_updated: new Date().toISOString(),
      });
    }
    return transactions;
  }

  private getRandomTransactionType(): Transaction['type'] {
    const types = Object.values(TransactionType);
    return types[Math.floor(Math.random() * types.length)];
  }

  private getRandomTransactionStatus(): Transaction['status'] {
    const statuses = Object.values(TransactionStatus).filter(
      (status) =>
        status !== TransactionStatus.ALL &&
        status !== TransactionStatus.CANCELED,
    );
    return statuses[Math.floor(Math.random() * statuses.length)];
  }
}
